import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useCidco } from "./CidcoLayout";
import PublicAcademicsPage from "@/components/PublicAcademicsPage";

export default function Academics() {
  const data = useCidco();
  const docs = data.academics || [];
  return (
    <div data-testid="cid-ac-wrap">
      <PageHero eyebrow="Academic Resources" title="Academics" />
      <PageBody>
        <PublicAcademicsPage docs={docs} theme="cyan" testidPrefix="cid-ac" />
      </PageBody>
    </div>
  );
}
